import styled from 'styled-components'
import { Container } from '@chakra-ui/react'

export const FormWrapper = styled.div`
  background: #8bc34a;
  padding: 5em;
  margin-bottom: -96px;

  @media (max-width: 768px) {
    padding: 0;
    height: 85ch;

    .css-wclpxa {
      display: inline-block;
    }
    input {
      margin-bottom: 10px;
    }
  }
  input {
    background: white;
  }

  button {
    display: flex;
    margin: 0 auto;
  }

  textarea {
    background: white;
    margin-top: 20px;
    margin-bottom: 20px;
    height: 168px;
  }

  .chakra-container {
    max-width: 90ch;
  }

  p {
    margin: 5px 0px 56px;
  }
`

export const ContainerWrapper = styled(Container)`
  display: none;
`
